<template>
  <div class="main-con el-main">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "PageContent"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PageContent.vue